export default __webpack_public_path__ + "static/media/vertical_response.71ce36dc.png";